module.exports = __webpack_public_path__ + "img/location.99ef80bc.svg";